import React from "react";
import * as S from "./styles";

const RTF = ({ dangerouslySetInnerHTML, children, ...rest }) => {
  if (dangerouslySetInnerHTML) {
    return (
      <S.Container
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        {...rest}
      />
    );
  }
  return <S.Container {...rest}>{children}</S.Container>;
};

export default RTF;
